import React from 'react';
import 'style/block/contents.css';
import MsgBlock from 'js/views/components/block/msg-block';
function Contents(){
  return(
    <div className="contents">
      <MsgBlock />
    </div>
  );
}

export default Contents;